function LinesClearedDisplay ({ linesCleared }) {
    return (
        <div className="info-display">
            Lines: { linesCleared }
        </div>
    );
}

export default LinesClearedDisplay;